import { useEffect } from 'react';

import { AppRoutes } from 'config';
import { useNavigate } from 'hooks';
import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Popup } from 'components/popup';
import { Button } from 'components/button';
import { useAppDispatch, useAppSelector } from 'store';
import {
  fetchNotifications,
  notificationsStore,
} from 'store/slices/notifications';

import * as Styles from './styles';
import { NotificationCard } from './card';
import { NotificationHeader } from './header';
import { useManagerCompletionAlertsQuery } from 'store/api/cart';
import { CompletionAlertCard } from './completion-alert-card';

export const NotificationsPopup = ({ generalNotifications = true }: { generalNotifications?: boolean }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLoading, unreadCount, notifications } =
    useAppSelector(notificationsStore);

  const { data: alerts = [] } = useManagerCompletionAlertsQuery(undefined, {
    pollingInterval: 30000, refetchOnFocus: true,
  });
  useEffect(() => {
    if (generalNotifications) dispatch(fetchNotifications());
  }, [generalNotifications, dispatch]);
  const visibleNotifications = generalNotifications ? notifications : [];
  if (!generalNotifications && !alerts.length) return null;

  return (
    <Popup
      removeAutofocus
      position={['bottom center', 'bottom left', 'bottom right']}
      trigger={
        <Styles.StyledButton
          padding="0"
          transparent
          icon={<Icon.Bell />}
          disabled={generalNotifications && isLoading && !alerts.length}
          title="Notifications"
          hasUnreadCount={!!alerts.length || (generalNotifications && !!unreadCount)}
          colorType={ButtonColors.BlackWhite}
        />
      }
    >
      {(close) =>
        (alerts.length || visibleNotifications?.length) ? (
          <Styles.Container>
            {generalNotifications && <NotificationHeader isDialog unreadCount={unreadCount} />}
            <Styles.Content>
              {alerts.map(alert => <CompletionAlertCard key={alert.id} alert={alert} close={close} />)}
              {visibleNotifications?.map((notification, i) => (
                <NotificationCard
                  isDialog
                  close={close}
                  showDivider={i > 0 || alerts.length > 0}
                  key={notification.id}
                  notification={notification}
                />
              ))}
            </Styles.Content>

            {generalNotifications && <Button
              transparent
              padding="16px"
              text="View all"
              colorType={ButtonColors.LightBlue}
              onClick={() => {
                close();
                navigate(AppRoutes.Notifications.Home);
              }}
            />}
          </Styles.Container>
        ) : (
          <Styles.StyledPlaceholder text="No notifications" />
        )
      }
    </Popup>
  );
};

export { NotificationCard, NotificationHeader };
